import { useState } from "react";
import { pageVisitAt, type PageVisit } from "./siderail-state";

/**
 * State for one visit to a page: it clears whenever the pathname changes,
 * including on a return to a page visited before. The reset happens during
 * render (the previous-props pattern), so no frame shows the stale choice.
 */
export function usePageVisit<T>(
  pathname: string
): [T | null, (value: T | null) => void] {
  const [visit, setVisit] = useState<PageVisit<T>>({ path: pathname, value: null });
  const current = pageVisitAt(visit, pathname);
  if (current !== visit) setVisit(current);

  return [current.value, (value) => setVisit({ path: pathname, value })];
}
